<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('medical services')"
      :columns="columns"
      :column_search="true"
      resource_url="/patient/medical-service/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <medical-service-modal ref="medical_service_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
} from "@/utils";
import MedicalServiceModal from "./medical_service_modal/Index.vue";

export default {
  name: "PatientDatatable",
  components: { GenericTable, MedicalServiceModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          // width: "60%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("list price"),
          searchable: false,
          // width: "20%",
          data: (row) => {
            return format_currency(row.price);
          },
        },
        // {
        //   title: v.$t("location"),
        //   name: "location",
        //   searchable: true,
        //   // width: "20%",
        //   data: (row) => {
        //     return row.location || "";
        //   },
        // },
        // {
        //   title: v.$t("status"),
        //   searchable: false,
        //   // width: "20%",
        //   data: (row) => {
        //     return v.translate_status(row.status_code);
        //   },
        // },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "20%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.medical_service_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete medical service?"),
                    v,
                    () => {
                      del("/patient/medical-service", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.medical_service_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
